import { Card, CardBody, Col, ListGroup, ListGroupItem } from "reactstrap";
import { H6, Image, P } from "../../../../AbstractElements";
import { CustomListTitle } from "../../../../Constants/Constants";
import { CustomListData, CustomListSubTitle } from "../../../../Data/UiKits/Lists";
import { dynamicImage } from "../../../../Utils";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";

const CustomList = () => {
  return (
    <Col md="12">
      <Card>
        <CommonCardHeader title={CustomListTitle} span={CustomListSubTitle} />
        <CardBody>
          <ListGroup className="main-lists-contents">
            {CustomListData &&
              CustomListData.map((item, index) => (
                <ListGroupItem action className={`${item.class}`} key={index}>
                  <div className="d-flex w-100 justify-content-between align-items-center">
                    <div className="list-wrapper">
                      <Image className="list-img" src={dynamicImage(`user/${item.image}`)} alt="profile" />
                      <div className="list-content">
                        <H6 className={index === 0 ? "txt-light" : ""}>{item.head}</H6>
                        <P>{item.mail}</P>
                      </div>
                    </div>
                    <small>{item.span}</small>
                  </div>
                  <P className="mb-1">{item.subtext}</P>
                  <small className={index !== 0 ? "text-muted" : ""}>{item.follower}</small>
                </ListGroupItem>
              ))}
          </ListGroup>
        </CardBody>
      </Card>
    </Col>
  );
};
export default CustomList;
